import React, { useEffect, useState } from 'react';
import './scss/PlayerCredits.scss';
import Header from './Header';

function PlayerCredits() {
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    const fetchPlayerCredits = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_API_URL + '/get_player_credits.php');
        const result = await response.json();
        if (result.success) {
          setPlayers(result.data);
        } else {
          console.error('Failed to fetch player credits');
        }
      } catch (error) {
        console.error('Error fetching player credits:', error);
      }
    };

    fetchPlayerCredits();
  }, []);

  return (
    <div className="PlayerCredits container">
      <Header />
      <h1>Player Credits</h1>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Played</th>
            <th>Credits</th>
          </tr>
        </thead>
        <tbody>
          {players.map((player, index) => (
            <tr key={index}>
              <td>{player.name}</td>
              <td>{player.played}</td>
              <td>
                {player.status}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PlayerCredits; 